export default "__VITE_ASSET__3CmQegTr__"